/* ==========================================================================
   GLW: keep the header cart badge in sync with Rebuy's SmartCart drawer

   Dawn's header cart-count-bubble is plain server-rendered Liquid, baked in
   at page load. With cart_type "page" there's no <cart-drawer> or
   <cart-notification> in the DOM, so Dawn's own live-update scripts
   (cart-drawer.js, cart-notification.js) never activate — and Rebuy manages
   cart mutations (add/remove/quantity) entirely through its own UI, without
   touching Dawn's pub/sub cart-update events. Net result: the header badge
   only reflects reality after a full page load/reload. Confirmed this is
   also production's behavior (no theme code there updates it live either),
   so this is a genuine enhancement over production, not a parity fix.

   APPROACH
   Watch Rebuy's cart container for any change (item added/removed, quantity
   edited), debounce, then ask Shopify's own /cart.js for the authoritative
   item count and update the badge from that — rather than parsing Rebuy's
   own display copy, which could change wording independent of us.

   .rebuy-cart may not exist yet when this runs (Rebuy initializes
   asynchronously), so a short-lived body-wide watcher waits for it to
   appear, then hands off to a targeted observer scoped to just that
   subtree. The badge <div class="cart-count-bubble"> itself may not exist
   yet either (Dawn's header only renders it {%- if cart != empty -%}), so
   this creates/removes it to match, rather than requiring a template edit.

   SCOPING
   Loaded unconditionally from theme.liquid, same as its CSS counterpart —
   the drawer can open from any add-to-cart button on any page.
   ========================================================================== */
(function () {
  var CART_LINK_ID = 'cart-icon-bubble';
  var REBUY_ROOT_SELECTOR = '.rebuy-cart';
  var DEBOUNCE_MS = 400;

  function updateBadge(cart) {
    var cartLink = document.getElementById(CART_LINK_ID);
    if (!cartLink) return;
    var bubble = cartLink.querySelector('.cart-count-bubble');

    if (cart.item_count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartLink.appendChild(bubble);
      }

      var countSpan = bubble.querySelector('span[aria-hidden="true"]');
      if (cart.item_count < 100) {
        if (!countSpan) {
          countSpan = document.createElement('span');
          countSpan.setAttribute('aria-hidden', 'true');
          bubble.insertBefore(countSpan, bubble.firstChild);
        }
        countSpan.textContent = cart.item_count;
      } else if (countSpan) {
        countSpan.remove();
      }

      var hiddenSpan = bubble.querySelector('.visually-hidden');
      if (!hiddenSpan) {
        hiddenSpan = document.createElement('span');
        hiddenSpan.className = 'visually-hidden';
        bubble.appendChild(hiddenSpan);
      }
      // Matches locales/en.default.json sections.header.cart_count.
      hiddenSpan.textContent = cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items');
    } else if (bubble) {
      bubble.remove();
    }
  }

  var syncTimer;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(updateBadge)
        .catch(function () {
          /* Network hiccup — badge just stays as it was until the next change. */
        });
    }, DEBOUNCE_MS);
  }

  function observeRebuyCart(root) {
    new MutationObserver(scheduleSync).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  var existingRoot = document.querySelector(REBUY_ROOT_SELECTOR);
  if (existingRoot) {
    observeRebuyCart(existingRoot);
    return;
  }

  var watcher = new MutationObserver(function () {
    var root = document.querySelector(REBUY_ROOT_SELECTOR);
    if (root) {
      watcher.disconnect();
      observeRebuyCart(root);
    }
  });
  watcher.observe(document.body, { childList: true, subtree: true });
})();
